import { render, staticRenderFns } from "./SubscriptionDataTable.vue?vue&type=template&id=00ef2e4e&scoped=true&"
import script from "./SubscriptionDataTable.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionDataTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ef2e4e",
  null
  
)

export default component.exports